import { Container, DownloadButton, FileInfo, FileStatus } from './style'

import { MdCheckCircle, MdDownload, MdError } from 'react-icons/md'
import { Loader, Popup } from 'semantic-ui-react'


export default function FileList({ files, removeFile, downloadFile }){
    return(
        <Container>
            {files.map(file => (
                <li key={file.id}>
                    <FileInfo>
                        <div>
                            <strong>{file.name}</strong>
                            <span>{file.readableSize}
                                {file.removable && <button onClick={() => removeFile(file.id)}>Remover</button>}
                            </span>
                        </div>
                    </FileInfo>
                    <FileStatus>
                        {
                            file.success && 
                            <DownloadButton onClick={() => downloadFile(file)}>
                                <MdDownload size={24}/>
                            </DownloadButton>
                        }
                        {file.inProcess && <Loader active size='small' inline/>} 
                        {file.success && <MdCheckCircle size={24} color='#28A745'/>} 
                        {file.error && <Popup content={file.errorDescription} trigger={<MdError size={24} color='#DC3545'/>} />}
                    </FileStatus>
                </li>
            ))}
        </Container>
    )
}